"use strict";
const angular = require("angular");

export class IntroductionController {
  constructor(arrow, LanguageService) {
    "ngInject";
    this.arrow = arrow;
    this.ls = LanguageService;
  }
}

export default angular
  .module("dalApp.permission.introduction", [])
  .component("introduction", {
    template: require("./introduction.html"),
    controller: IntroductionController,
  }).name;



// WEBPACK FOOTER //
// ./client/app/permission/introduction/introduction.component.js